import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import twcSeal from "../../Assets/twc-seal.png";

function GrievanceAppealsPolicy() {
  return (
    <Container fluid className="about-section policy-page">
      <Particle />
      <Container className="policy-container">
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <header className="policy-header">
              <img
                src={twcSeal}
                alt="Texas Workforce Commission seal"
                className="policy-seal"
              />
              <h1 className="policy-title">
                Grievance / <span className="purple">Appeals Policy</span>
              </h1>
              <p className="policy-lead">
                Students are encouraged to resolve concerns directly with the school.
              </p>
            </header>

            <section className="policy-card" aria-label="How to file a complaint">
              <h2 className="policy-section-title">If a complaint cannot be resolved</h2>
              <p className="policy-text">
                The student may file a complaint with the following agency:
              </p>

              <address className="policy-address">
                <div className="policy-address-title">Texas Workforce Commission</div>
                <div>Career Schools and Colleges, Room 226T</div>
                <div>101 East 15th Street</div>
                <div>Austin, Texas 78778-0001</div>
              </address>

              <div className="policy-meta">
                <div>
                  <span className="policy-meta-label">Phone</span>
                  <span className="policy-meta-value">512-936-3100</span>
                </div>
                <div>
                  <span className="policy-meta-label">Email</span>
                  <a
                    className="policy-link"
                    href="mailto:career.schools@twc.texas.gov"
                  >
                    career.schools@twc.texas.gov
                  </a>
                </div>
                <div>
                  <span className="policy-meta-label">Website</span>
                  <a
                    className="policy-link"
                    href="http://texasworkforce.org/careerschoolstudents"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    texasworkforce.org/careerschoolstudents
                  </a>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default GrievanceAppealsPolicy;
